module.exports = __webpack_public_path__ + "static/img/rob-bright.ee214807.png";